// Note: signing methods are stored in the database, so this is not intended
// to be a complete list. This list is only for specific types with display logic.
export enum eSigningMethod {
  eSign = 'e-sign',
  wetSign = 'wet-sign',
  notaryOnly = 'notary',
  eSignNotary = 'e-sign-notary',
  ronOtherCircunstances = 'online-with-notes',
  thirdPartyNotary = 'third-party-notary',
  attorney = 'attorney',
  ron = 'online',
}

export const signingMethodsNotRequiringWitness: string[] = [eSigningMethod.eSign, eSigningMethod.wetSign];
